import { GlobalConstants } from '../constants/global.constant';
import * as FormFactorsConfigData from './../../../assets/config/form-factors.json';
import {
  FormFactor,
  FormFactorResponse, FormFactorsConfig
} from './../../modules/asset-library/form-factors/interfaces/form-factors.i';
import { throwError } from 'rxjs';
import { LANGUAGE_MAPPINGS } from '../../common/constants/language-mappings.const';
import { LANGUAGE_MAPPINGS_OEM } from '../../common/constants/language-mappings-oem.const';
import moment from 'moment';


export class Utils {

  static getFormFactorNames(formFactorValues: FormFactorResponse): FormFactor {
    const formFactorsConfigData: FormFactorsConfig = (FormFactorsConfigData as any)
      .default;
    let formfactorNames: FormFactor;
    if (formFactorValues.allDevices) {
      formfactorNames = {
        allDevices: formFactorValues.allDevices,
        devices: GlobalConstants.ALL,
        manufacturer: GlobalConstants.ALL,
        processors: GlobalConstants.ALL,
        generations: GlobalConstants.ALL
      };
    } else {
      let manufacturerNames = '';
      let deviceNames = '';
      let processorNames = '';
      let generationNames = '';
      if (formFactorValues.manufacturer) {
        if (formFactorValues.manufacturer.length === 0) {
          manufacturerNames = GlobalConstants.ALL;
        } else {
          manufacturerNames = formFactorValues.manufacturer
            .map((formFactorValue, index) =>
              formFactorsConfigData.manufacturers
                .map((formfactor, i) =>
                  formfactor.value === formFactorValue ? formfactor.name : null
                )
                .filter(v => v !== null)
            )
            .join(', ');
        }
      }
      if (formFactorValues.devices) {
        if (formFactorValues.devices.length === 0) {
          deviceNames = GlobalConstants.ALL;
        } else {
          deviceNames = formFactorValues.devices
            .map((formFactorValue, index) =>
              formFactorsConfigData.deviceTypes
                .map((formfactor, i) =>
                  formfactor.value === formFactorValue ? formfactor.name : null
                )
                .filter(v => v !== null)
            )
            .join(', ');
        }
      }
      if (formFactorValues.processors) {
        if (formFactorValues.processors.length === 0) {
          processorNames = GlobalConstants.ALL;
        } else {
          processorNames = formFactorValues.processors
            .map((formFactorValue, index) =>
              formFactorsConfigData.processors
                .map((formfactor, i) =>
                  formfactor.value === formFactorValue ? formfactor.name : null
                )
                .filter(v => v !== null)
            )
            .join(', ');
        }
      }
      if (formFactorValues.generations) {
        if (formFactorValues.generations.length === 0) {
          generationNames = GlobalConstants.ALL;
        } else {
          generationNames = formFactorValues.generations
            .map((formFactorValue, index) =>
              formFactorsConfigData.generation
                .map((formfactor, i) =>
                  formfactor.value === formFactorValue ? formfactor.name : null
                )
                .filter(v => v !== null)
            )
            .join(', ');
        }
      }
      formfactorNames = {
        allDevices: formFactorValues.allDevices,
        manufacturer: manufacturerNames,
        devices: deviceNames,
        processors: processorNames,
        generations: generationNames
      };
    }

    return formfactorNames;
  }

  static getFormFactorValues(formFactorNames: FormFactor): FormFactor {
    const formFactorsConfigData: FormFactorsConfig = (FormFactorsConfigData as any)
      .default;
    let formfactorValues: any;
    if (formFactorNames.allDevices) {
      formfactorValues = {
        allDevices: formFactorNames.allDevices,
        manufacturer: [],
        devices: [],
        processors: [],
        generations: []
      };
    } else {
      let manufacturerValues = [];
      let deviceValues = [];
      let processorValues = [];
      let generationValues = [];
      if (formFactorNames.manufacturer) {
        if (formFactorNames.manufacturer === GlobalConstants.ALL) {
          const allValues = formFactorsConfigData.manufacturers.map(
            (checked, i) => formFactorsConfigData.manufacturers[i].value
          );
          manufacturerValues = [];
        } else {
          manufacturerValues = formFactorsConfigData.manufacturers
            .map((manufacturer, i) =>
              formFactorNames.manufacturer.includes(manufacturer.name)
                ? manufacturer.value
                : null
            )
            .filter(v => v !== null);
        }
      }
      if (formFactorNames.devices) {
        if (formFactorNames.devices === GlobalConstants.ALL) {
          const allValues = formFactorsConfigData.deviceTypes.map(
            (checked, i) => formFactorsConfigData.deviceTypes[i].value
          );
          deviceValues = [];
        } else {
          deviceValues = formFactorsConfigData.deviceTypes
            .map((deviceType, i) =>
              formFactorNames.devices.includes(deviceType.name)
                ? deviceType.value
                : null
            )
            .filter(v => v !== null);
        }
      }
      if (formFactorNames.processors) {
        if (formFactorNames.processors === GlobalConstants.ALL) {
          const allValues = formFactorsConfigData.processors.map(
            (checked, i) => formFactorsConfigData.processors[i].value
          );
          processorValues = [];
        } else {
          processorValues = formFactorsConfigData.processors
            .map((processor, i) =>
              formFactorNames.processors.includes(processor.name)
                ? processor.value
                : null
            )
            .filter(v => v !== null);
        }
      }
      if (formFactorNames.generations) {
        if (formFactorNames.generations === GlobalConstants.ALL) {
          const allValues = formFactorsConfigData.generation.map(
            (checked, i) => formFactorsConfigData.generation[i].value
          );
          generationValues = [];
        } else {
          generationValues = formFactorsConfigData.generation
            .map((gen, i) =>
              formFactorNames.generations.includes(gen.name) ? gen.value : null
            )
            .filter(v => v !== null);
        }
      }

      formfactorValues = {
        allDevices: formFactorNames.allDevices,
        manufacturer: manufacturerValues,
        devices: deviceValues,
        processors: processorValues,
        generations: generationValues
      };
    }

    return formfactorValues;
  }

  // static getCurrentDate() {
  //   var today = new Date();
  //   var dd = today.getDate();
  //   var mm = today.getMonth() + 1;
  //   var yyyy = today.getFullYear();
  //   var hour = today.getHours();
  //   var minute = (today.getMinutes() < 10 ? '0' : '') + today.getMinutes(); //leading zero was missing.  
  //   var dateInfo = `${mm}/${dd}/${yyyy}`;
  //   var time = `${hour}:${minute}`;
  //   var timeZone = today.toTimeString().slice(9);
  //   if (timeZone.length > 30) {
  //     timeZone = timeZone.substring(0, 30);
  //     timeZone = `${timeZone}...`;
  //   }
  //   var currentDateResult = `${dateInfo} ${time} ${timeZone}`;
  //   currentDateResult = currentDateResult.toString().replace('GMT', 'UTC');
  //   return currentDateResult;
  // }

  static getCurrentDate() {
    const today = new Date();

    // Pad day, month, hour, and minute to ensure two digits
    const dd     = String(today.getDate()).padStart(2, '0');
    const mm     = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy   = today.getFullYear();
    const hour   = String(today.getHours()).padStart(2, '0');
    const minute = String(today.getMinutes()).padStart(2, '0');

    const datePart = `${mm}/${dd}/${yyyy}`;
    const timePart = `${hour}:${minute}`;

    // Process the timezone string here
    let timeZoneString = today.toTimeString();

    let relevantTzPart = "";
    const firstSpaceIndex = timeZoneString.indexOf(' ');
    if (firstSpaceIndex > -1) {
      relevantTzPart = timeZoneString.substring(firstSpaceIndex + 1);
    }

    relevantTzPart = relevantTzPart.replace(/GMT/g, 'UTC'); // Replace all GMT with UTC (globally)

    // Check for the "Name (UTC±Offset)" pattern and reorder it to "UTC±Offset (Name)"
    // This'd ensure that it never goes into "Name (UTC±Offset)" format even intermittently hence addressing that 1% of the issue
    const nameThenOffsetPattern = new RegExp(/^([^(]+)\s*\((UTC[+-]\d{4})\)$/);
    const match                 = relevantTzPart.match(nameThenOffsetPattern);

    if (match) {
        const name     = match[1].trim();
        const offset   = match[2];
      relevantTzPart = `${offset} (${name})`;
    }
    // If it doesn't match, we can assume relevantTzPart is already in the correct "UTC±Offset (Name)" format
    // Truncate the timezone string if it's too long (ensuring total length with "..." is max 30)
    if (relevantTzPart.length > 30) {
      relevantTzPart = `${relevantTzPart.substring(0, 27)}...`;
    }

    // Construct the result string
    const currentDateResult = `${datePart} ${timePart} ${relevantTzPart}`;

    // The original code had a .toString() here, which is redundant as it's already a string.
    // The replace('GMT', 'UTC') is also moved up to handle it more comprehensively.
    return currentDateResult;
  }


  static validateUrl(inputUrl: string): boolean {
    let isUrlValid = false;

    try {
      const pattern = new RegExp(GlobalConstants.SRT_URL);
      isUrlValid = pattern.test(inputUrl);
    } catch (e) {
      // TODO: Handle error here
    }

    return isUrlValid;
  }

  static customDateCheck = (publishDate, expireDate): boolean => {
    let newpublishDate = publishDate === 'Now' ? new Date() : new Date((publishDate.split(' ')[0] + ' ' + publishDate.split(' ')[1]) + ' ' + (publishDate.split(' ').slice(-1)[0].replace(/[{()}]/g, '')));
    let newexpireDate = new Date((expireDate.split(' ')[0] + ' ' + expireDate.split(' ')[1]) + ' ' + (expireDate.split(' ').slice(-1)[0].replace(/[{()}]/g, '')));
    return newpublishDate >= newexpireDate
  }

  static trimString(str: string) {
    return str.length > 30 ?
      str.substring(0, 30) + "..." :
      str;
  }

  //Handling error within the component
  static handleError(error, componentName) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}\nComponent: ${componentName}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.responseContext.exceptionResponse.errorCode}\nMessage: ${error.responseContext.exceptionResponse.errorMessage} with Status Code: ${error.responseContext.exceptionResponse.statusCode}\nComponent: ${componentName}`;
    }
    return throwError(errorMessage);
  }

  //idleTimeData
  static getIdleTimeData() {
    let data = {
      '30': GlobalConstants.THIRTY_SEC,
      '45': GlobalConstants.FORTYFIVE_SEC,
      '60': GlobalConstants.ONE_MINUTE,
      '90': GlobalConstants.ONE_AND_HALF_MINUTE,
      '120': GlobalConstants.TWO_MINUTES,
      '300': GlobalConstants.FIVE_MINUTES,
      '600': GlobalConstants.TEN_MINUTES,
      '1200': GlobalConstants.TWENTY_MINUTES,
    };
    return data;
  }

  //Added: 24-Nov-21
  //Function to change publish/expire date to new format
  //e.g: 04/01/2021 00:00 UTC+0530 (Indian Standard Time)
  static changeSaveDateFormat(dateString: string) {
    try {      
      if (GlobalConstants.DATEFORMAT_REGEX_EXPECTED.test(dateString)) { // IIT2-21953 for when date is in expected format 04/01/2021 00:00 UTC+0530 (Indian Standard Time) 
        return dateString;
      }
      let dateValue = dateString.split(GlobalConstants.DATEFORMAT_SPACE_REGEX);
      let utcVal = dateString.match(GlobalConstants.DATEFORMAT_PARENTHESIS_REGEX)[1];
      let timeZoneName = dateValue[1].split(GlobalConstants.DATEFORMAT_SPACE_REGEX)[1].replace(GlobalConstants.DATEFORMAT_PARENTHESIS_REGEX, '').trim();
      let finalDateStr = `${dateValue[0]} ${dateValue[1].split(GlobalConstants.DATEFORMAT_SPACE_REGEX)[0]} ${utcVal} (${timeZoneName})`;
      return finalDateStr;
    } catch (err) {
    }
  }

  //Added: 24-Nov-21
  //Function to change publish/expire date to old format
  //e.g: 04/01/2021 00:00 Indian Standard Time (UTC+0530)
  static ChangetoOldFormat(dateString: string) {
    try {
      let dateValue = dateString.split(GlobalConstants.DATEFORMAT_SPACE_REGEX);
      let min = dateValue[1].split(GlobalConstants.DATEFORMAT_SPACE_REGEX)[0];
      let tz_offset = dateValue[1].split(GlobalConstants.DATEFORMAT_SPACE_REGEX)[1];
      let utcVal = tz_offset.split(GlobalConstants.DATEFORMAT_SPACE_REGEX)[0];
      let timeZoneName = tz_offset.split(GlobalConstants.DATEFORMAT_SPACE_REGEX)[1].substring(1).slice(0, -1);
      let finalDateStr = `${dateValue[0]} ${min} ${timeZoneName} (${utcVal})`;
      return finalDateStr;
    } catch (err) {
    }
  }

  //Commenting the below code as the formatting is wrong
  //Function to change publish/expire date to new format
  //04/01/2021 00:00 UTC+0530 Indian Standard Time
  // static changeSaveDateFormat(dateStr: string){
  //   try{
  //     let splitSample = dateStr.split(' ');
  //     let sampleStr = 
  //     `${splitSample[0]} ${splitSample[1]} ${splitSample[5].replace(/[()]/g,'')} ${splitSample[2]} ${splitSample[3]} ${splitSample[4]}`;
  //     return sampleStr;
  //   }
  //   catch(err){
  //     console.log(err);
  //   }
  // }

  //Commenting the below code as the formatting is wrong
  //Function to change publish/expire date to old format
  //04/01/2021 00:00 Indian Standard Time (UTC+0530) 
  // static ChangetoOldFormat(dateStr: string){
  //   try{
  //     let splitSample = dateStr.split(' ');
  //     let sampleStr = 
  //     `${splitSample[0]} ${splitSample[1]} ${splitSample[3]} ${splitSample[4]} ${splitSample[5]} (${splitSample[2]})`;
  //     return sampleStr;
  //   }
  //   catch(err){
  //     console.log(err);
  //   }
  // }

  static getOperatingSystemTypes(data) {
    let osName;
    if (data === GlobalConstants.LINUX_TEXT) {
      osName = GlobalConstants.LINUX_OS;
    } else if (data === GlobalConstants.WINDOWS_10S) {
      osName = GlobalConstants.WINDOWSUWP;
    } else if (data === GlobalConstants.CHROME_TEXT) {
      osName = GlobalConstants.CHROME_TYPE;
    } else if (data === 'IPOSLITE') {
      osName = GlobalConstants.IPOS_LITE;
    } else {
      osName = GlobalConstants.WINDOWS_OS;
    }

    return osName;
  }

  static getOperatingSystemTypeFromServer(data) {
    let osName;
    if (data === GlobalConstants.LINUX_OS) {
      osName = GlobalConstants.LINUX_TEXT;
    } else if (data === GlobalConstants.WINDOWSUWP) {
      osName = GlobalConstants.WINDOWS_10S;
    } else if (data === GlobalConstants.CHROME_TYPE) {
      osName = GlobalConstants.CHROME_TEXT;
    } else {
      osName = GlobalConstants.WINDOWS;
    }

    return osName;
  }
  static checkOSTypeWindowsOrUWP(profileData) {
    const osType = JSON.parse(profileData.settings).otherSettings.operatingSystem;
    return [GlobalConstants.WINDOWS_OS, GlobalConstants.WINDOWSUWP]?.includes(osType);
  }

  static getDifference(generatedDate) {
    let diff = (new Date().getTime() - generatedDate.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }

  static decodeLanguageByCode(code: string) {
    for (let lang of LANGUAGE_MAPPINGS) {
      if (lang.langCode.toLowerCase() === code) {
        return lang.langInEng.split(' - ')[0];
      }
    }
  }

  static decodeLanguageByCodeout(code: string) {
    for (let lang of LANGUAGE_MAPPINGS_OEM) {
      if (lang.langCode === code) {
        return lang.langInEng;
      }
    }
  }

  static decodeLanguageByCodeIn(code: string) {
    for (let lang of LANGUAGE_MAPPINGS) {
      if (lang.langCode === code) {
        return lang.langInEng;
      }
    }
  }

  static decodeCodeByLanguage(language: string) {
    for (let lang of LANGUAGE_MAPPINGS) {
      if (lang.langInEng === language) {
        return lang.langCode;
      }
    }
  }

  //Filter out extra languages from mapping which are not required for CHROME OS
  static filterChromeLanguages() {
    let limitLanguages = ['da', 'nl', 'en-US', 'fi', 'fr', 'de', 'is', 'it', 'ja', 'ko', 'no', 'es', 'es-mx', 'sv', 'zh-Hant', 'zh-tw'];
    let newLangSet = LANGUAGE_MAPPINGS.filter(function (value) {
      return limitLanguages.includes(value.langCode);
    });
    return newLangSet;
  }

  //Content group common functions
  static getFontSize(size: number) {
    if (size === GlobalConstants.NUMBER_12) { return GlobalConstants.SMALL; }
    if (size === GlobalConstants.NUMBER_14) { return GlobalConstants.MEDIUM; }
    if (size === GlobalConstants.NUMBER_16) { return GlobalConstants.LARGE; }
  }

  static getUILayoutIDByName(name: string) {
    if (name === GlobalConstants.TWO_COL_RIGHT_ASSET) {
      return 1;
    } else if (name === GlobalConstants.TWO_COL_LEFT_ASSET) {
      return 2;
    } else if (name === GlobalConstants.ONE_COL_MID_ASSET) {
      return 3;
    }
  }

  static formatDate(data) {
    return `${moment(data.dateVal).format(GlobalConstants.DATE_FORMAT)} ${data.hour}:${data.min} ${data.timeZone}`;
  }

  static isCustomStatus(status) {
    return (status === GlobalConstants.CUSTOM);
  }
  //To avoid repeated code.
  static checkRole(userRole) {
    if (userRole === GlobalConstants.RETAIL_HQ_USER || userRole === GlobalConstants.STORE_USER || userRole === GlobalConstants.REGIONALHQ) {
      return true;
    } else {
      return false;
    }
  }
  //Default metadata set for Standard download package page IIT2-5802
  static getPkgMetaData() {
    return {
      standard: {
        "packageType": "win",
        "standardPack": "standard",
        "langObject": {},
        "data": []
      },
      iso: {
        "packageType": "iso",
        "standardPack": "standard",
        "langObject": {},
        "data": []
      },
      deb: {
        "packageType": "deb",
        "standardPack": "standard",
        "langObject": {},
        "data": []
      },
      gaming: {
        "packageType": "win",
        "standardPack": "gaming",
        "langObject": {},
        "data": []
      },
      creator: {
        "packageType": "win",
        "standardPack": "creator",
        "langObject": {},
        "data": []
      },
      chromebook: {
        "packageType": "chrome",
        "standardPack": "chrome",
        "langObject": {},
        "data": []
      },
      uwp: {
        "packageType": "uwp",
        "standardPack": "uwpstandard",
        "langObject": {},
        "data": []
      },
      iposlite: {
        "packageType": "iposlite",
        "standardPack": "iposlite",
        "langObject": {},
        "data": []
      }
    };
  }
  static getdownloadLink() {
    let todayTime = new Date();
    let month = (todayTime.getMonth() + 1);
    let day = ('0' + todayTime.getDate()).slice(-2);
    let year = todayTime.getFullYear();
    let userFilename = month + '_' + day + '_' + year;
    return userFilename;
  }

  static downloadCsvFile(csvData, userfilename) {
    const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
    if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", userfilename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  // For IIT3-70 story
  static getHourDifference(inputDate) {
    let diffInHours = (new Date().getTime() - inputDate.getTime()) / 1000;
    diffInHours /= (60 * 60);
    return Math.abs(Math.round(diffInHours));
  }

  // For story IIT3-671
  static getFileXHRResponseContext(url) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open("HEAD", url);
      xhr.send();
      xhr.onload = function () {
        resolve(xhr.responseURL);
      };
    });
  }

  static getExpiredUnChangedContentdata(element) {
    if (element?.configurations?.expireTime && element?.configurations?.expireTime !== GlobalConstants.NEVER) {
      const checkPresentDate = new Date();
      const updatedTime = element?.configurations?.expireTime;
      if (new Date(updatedTime) < checkPresentDate) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  static getExpiredContentdata(element) {
    if (element?.configurations?.expireTime && element?.configurations?.expireTime !== GlobalConstants.NEVER) {
      const checkPresentDate = new Date();
      const updatedTime = Utils.changeSaveDateFormat(element?.configurations?.expireTime);
      if (new Date(updatedTime) < checkPresentDate) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
}